'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  // DASHBOARDS
  GET_DASHBOARDS_REQUESTED: null,
  GET_DASHBOARDS_SUCCEEDED: null,
  GET_DASHBOARDS_FAILED: null,
  // REPORTS
  GET_SAVED_REPORTS_REQUESTED: null,
  GET_SAVED_REPORTS_SUCCEEDED: null,
  GET_SAVED_REPORTS_FAILED: null,
  GET_REPORT_TEMPLATE_SEARCH_REQUESTED: null,
  GET_REPORT_TEMPLATE_SEARCH_SUCCEEDED: null,
  GET_REPORT_TEMPLATE_SEARCH_FAILED: null,
  GET_AI_SEARCH_REQUESTED: null,
  GET_AI_SEARCH_SUCCEEDED: null,
  GET_AI_SEARCH_FAILED: null,
  GET_ALL_RESTORABLE_REPORTS_REQUESTED: null,
  GET_ALL_RESTORABLE_REPORTS_SUCCEEDED: null,
  GET_ALL_RESTORABLE_REPORTS_FAILED: null,
  GET_REPORT_REQUESTED: null,
  GET_REPORT_SUCCEEDED: null,
  GET_REPORT_FAILED: null,
  CLEAR_REPORT: null,
  UPDATE_REPORT_REQUESTED: null,
  UPDATE_REPORT_SUCCEEDED: null,
  UPDATE_REPORT_FAILED: null,
  GET_REPORT_COUNTS_REQUESTED: null,
  GET_REPORT_COUNTS_SUCCEEDED: null,
  GET_REPORT_COUNTS_FAILED: null,
  GET_FILTERED_REPORT_COUNTS_REQUESTED: null,
  GET_FILTERED_REPORT_COUNTS_SUCCEEDED: null,
  GET_FILTERED_REPORT_COUNTS_FAILED: null,
  SET_TEMPLATES_LIMIT: null,
  // OWNERS
  OWNERS_REQUESTED: null,
  OWNERS_SUCCEEDED: null,
  OWNERS_FAILED: null,
  //FILTERS
  SET_FILTERS: null,
  CLEAR_FILTERS: null,
  SET_REPORT_FILTER_TITLE_SUCCEEDED: null,
  // HISTORY
  HISTORY_METHOD_CALLED: null,
  // AI SETTINGS
  AI_SETTINGS_REQUESTED: null,
  AI_SETTINGS_SUCCEEDED: null,
  AI_SETTINGS_FAILED: null,
  //FULLSCREEN SEARCH
  TOGGLE_FULLSCREEN_SEARCH: null,
  //TAGS
  GET_TAGS_PENDING: null,
  GET_TAGS_SUCCEEDED: null,
  GET_TAGS_FAILED: null
});